import React, { useEffect, useState } from "react"
import QRCode from "qrcode"
import PropTypes from "prop-types"

const QrCodeDisplay = ({ otpauthUrl }) => {
  const [qrCodeUrl, setQrCodeUrl] = useState("")

  useEffect(() => {
    if (otpauthUrl) {
      QRCode.toDataURL(otpauthUrl)
        .then(url => {
          setQrCodeUrl(url)
        })
        .catch(err => {
          console.error("Erro ao gerar o QR Code:", err)
        })
    }
  }, [otpauthUrl])

  return (
    <div>
      {qrCodeUrl ? (
        <img src={qrCodeUrl} alt="QR Code" />
      ) : (
        <p>Gerando QR Code...</p>
      )}
    </div>
  )
}

QrCodeDisplay.propTypes = {
  otpauthUrl: PropTypes.string,
}

export default QrCodeDisplay
